import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../assets/account.css';
import '../../assets/common.css';

const AccountDetail = () => {
    return (
        <div className="mb-5 content-main">
            <div className='row'>

                <div className='col-lg-3'>
                    {false ?
                        <img src="https://via.placeholder.com/40" className="account-profile-image" />
                        :
                        <div className='account-profile-image-FirstName'>Jim</div>}
                </div>
                <div className='col-lg-9'>
                    <div className='mb-3'>
                        <span className='account-profile-name'>Jim Liu</span>
                        <span className='account-profile-name-subtitle'>Blockchain Engineer</span>
                    </div>
                    <p className='postContentColor'>
                        Hi, I'm Jim, a software engineer specializing in blockchain technologies including Ethereum, Solidity, and Foundry. I have extensive experience in developing decentralized finance protocols, smart contracts with frontend integrations, and have been involved in multiple blockchain projects.
                    </p>
                    <div className='profileAdditioinInfoIcon'>
                        <a href="https://github.com/JUN-YAO-LIU" target="_blank" rel="noopener noreferrer" style={{ color: '#4a4a4a', transition: 'color 0.3s ease' }} onMouseOver={(e) => e.currentTarget.style.color = '#333'} onMouseOut={(e) => e.currentTarget.style.color = '#4a4a4a'}>
                            <span className="fa-brands fa-github"></span>
                        </a>
                        {/* <span className="fa-brands fa-line marginLeft10px"></span>
                        <span className="fa-brands fa-instagram marginLeft10px"></span> */}
                        <a href="mailto:jimliu.dev@gmail.com" style={{ color: '#007bff', marginLeft: '10px', transition: 'color 0.3s ease' }} onMouseOver={(e) => e.currentTarget.style.color = '#0056b3'} onMouseOut={(e) => e.currentTarget.style.color = '#007bff'}>
                            <span className="fa-solid fa-envelope"></span>
                        </a>
                    </div>
                </div>
            </div>

            <h6 className="boldtext mb-3 mt-3">Blockchain Experience</h6>
            <p>
                <strong>AppWorks Blockchain Program | 2024</strong><br/>
                • Completed specialized blockchain developer training covering key DeFi protocols<br/>
                • Utilized Solidity, Foundry, and Remix tools<br/>
                • Learned contract security, vulnerability analysis, and testing using Foundry<br/><br/>

                <strong>AppWorks Blockchain Program | 2024</strong><br/>
                • Shared implementation of multi-signature using the Aptos SDK at a public developer event.<br/> 
                Link:  https://youtu.be/sSMTVF5NnWA (37:25)<br/><br/>
                
                <strong>Credit-Pool (Side Project)</strong><br/>
                • Developed a decentralized credit protocol where users earn higher credit scores through frequent lending and borrowing activity.<br/>
                • Built smart contracts and frontend integration using Foundry, Solidity, and ethers.js.<br/><br/>
                
                <strong>GaoFen Fintech Co., Ltd. — Blockchain Engineer  | 2022 - 2023</strong><br/>
                • Researched and tested smart contracts.<br/>
                • POA Chain Development.<br/>
                • Studied common DeFi and staking contract mechanisms.<br/>
            </p>
            
            <h6 className="boldtext mb-3 mt-3">Work Experience</h6>
            <p>
                <strong>Eastern Home Shopping Co., Ltd | 2023 - 2024, Software Engineer</strong><br/>
                • Developed and maintained backend APIs and admin systems for shopping platform<br/>
                • Designed software architecture for scalable and maintainable systems<br/>
                • Tech Stack: C#, ASP.NET Core, Kafka, RabbitMQ, MySQL, MongoDB<br/><br/>
                
                <strong>GaoFen Fintech Co., Ltd. | 2022 - 2023, Blockchain Engineer</strong><br/>
                • Developed and maintained digital asset management system with AppStore/Google Purchase Store<br/>
                • Built ERC-20, ARC systems and crypto wallet backend APIs<br/><br/>
                
                <strong>Asia Zhiyuan Technology Co., Ltd. | 2020 - 2022</strong><br/>
                • Mobile Insurance System: Designed three web applications for internal, external, and mobile use<br/>
                • Solely responsible for system architecture, frontend development, and client communication<br/>
                • Migrated an existing system from WEB 2.0 to .NET 5 using modern infrastructure<br/><br/>
                
                <strong>ChiaoHe Digital Technology Co., Ltd. | 2019 - 2020</strong><br/>
                • Developed the backend for Yuanta ETF-AI Smart Investment Platform, providing users with ETF stock trends and investment information.
            </p>
            
            {/* <h6 className="boldtext mb-3 mt-3">學歷</h6>
            <p>
                <strong>輔仁大學 Fu Jen Catholic University | 2015 - 2019</strong><br/>
                電機工程學系學士學位
            </p>
            
            <h6 className="boldtext mb-3 mt-3">出版物</h6>
            <p>
                <strong>ASP.NET Core 6 零基礎建立自己的部落格 (2023)</strong>
            </p>
            
            <h6 className="boldtext mb-3 mt-3">獎項</h6>
            <p>
                <strong>Creative IoT Competition | 2018</strong><br/>
                獲得第二名，開發物聯網摩托車停車解決方案
            </p> */}
            
            <h6 className="boldtext mb-3 mt-3">Technical Skills</h6>
            <p>
                • Languages: C#, JavaScript, Solidity, Python, C<br/>
                • Frameworks: ASP.NET Core, React, Node.js, Foundry<br/>
                • Databases: MSSQL, MySQL<br/>
                • Cloud & DevOps: Azure, Docker, RabbitMQ, Redis, Jenkins<br/>
                • Blockchain: Ethereum, Solidity, Common ERC20, ERC721, ERC1155, ERC-4626, ERC-777, ERC-827, ERC-3525, ERC-6551<br/>
                • Blockchain - vulnerability: Reentrancy, Integer Overflow/Underflow, Frontrunning, Flash Loan Attacks, Access Control Issues, Unchecked Return Values, Oracle Manipulation, DoS Attacks, Gas Optimization Exploits, Logic Errors
            </p>
        </div>
    );
};

export default AccountDetail;